(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ts-slider]').forEach(function (slider) {
    var track = slider.querySelector('[data-ts-track]');
    var prevBtn = slider.querySelector('[data-ts-prev]');
    var nextBtn = slider.querySelector('[data-ts-next]');
    var dotsWrap = slider.parentElement.querySelector('[data-ts-dots]');
    var cards = Array.prototype.slice.call(track.children);
    if (!track || cards.length === 0) return;

    function cardStep() {
      var card = cards[0];
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || 0);
      return card.getBoundingClientRect().width + gap;
    }

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    function updateDots() {
      if (!dotsWrap) return;
      var index = Math.round(track.scrollLeft / cardStep());
      Array.prototype.slice.call(dotsWrap.children).forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    if (dotsWrap) {
      cards.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ts-dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', function () {
          track.scrollTo({ left: cardStep() * i, behavior: 'smooth' });
        });
        dotsWrap.appendChild(dot);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: cardStep(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(function () {
        updateArrows();
        updateDots();
      });
    });

    updateArrows();
    updateDots();

    if (slider.dataset.autoplay === 'true') {
      var speed = (parseFloat(slider.dataset.autoplaySpeed) || 5) * 1000;
      var timer = setInterval(function () {
        var maxScroll = track.scrollWidth - track.clientWidth - 2;
        if (track.scrollLeft >= maxScroll) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: cardStep(), behavior: 'smooth' });
        }
      }, speed);

      slider.addEventListener('mouseenter', function () { clearInterval(timer); });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
